import { useEffect, useState } from 'react';
import { UniformType, JobLevelsType } from '../model/datatype';
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export const ConfirmHandleErrorModal = (props: any) => {
  let { t } = useTranslation();
  useEffect(() => {}, []);

  return (
    <Modal
      show={props.showModal}
      onHide={props.handleContinue}
      backdrop="static"
      keyboard={true}
      className="confirmModal uniformModel"
    >
      <Modal.Header closeButton>
        <Modal.Title className="uniform-title text-danger">
          {t('uniform_survey.error_message.title')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="uniform-survey-info mb-0 mt-0">
          <Container>
            <Row
              className="uniform-job-level-item"
              style={{ display: props.style }}
            >
              <Col>
                <div className="text-center text-warning">
                  {props.errorMessage}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="text-center w-100">
          <Button className="btn-no mx-2" onClick={props.click_no}>
            {t('uniform_survey.error_message.btn_no')}
          </Button>
          <Button className="btn-yes mx-2" onClick={props.click_yes}>
            {t('uniform_survey.error_message.btn_again')}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
